import { useQuery } from "@apollo/client";
import { FiltersState, filtersToWhere } from "src/components/Filter";
import { searchContent } from "src/queries/searchContent";

const defaultWhere = {
  blocked: false,
  private: false,
};

export default function useGetDataSearchContent(
  filtersState: FiltersState,
  query: string,
  skip: boolean
) {
  const where = filtersToWhere(filtersState);

  return useQuery(searchContent, {
    variables: {
      sort: filtersState.sort,
      where: {
        ...where,
        ...defaultWhere,
        ...(query ? { _q: query } : {}),
      },
    },
    errorPolicy: "all",
    skip,
  });
}
